import { useMemo } from 'react'
import { useCompanyContext } from '@/lib/providers/CompanyProvider'
import ApplyForm from './ApplyForm'
import ApplicationClosed from './ApplicationClosed'
import ApplicationBefore from './ApplicationBefore'
import ResumeApplication from './ResumeApplication'
import StartLearning from './StartLearning'
import SubmissionComplete from './SubmissionComplete'
import ApplicationNone from './ApplicationNone'

interface ICTAProps extends React.HTMLAttributes<HTMLDivElement> {
  type: string
  startAt?: string | null
  endAt?: string | null
}

/** KTP 전용 커스텀 CTA 색상이 적용되는 기업 코드 */
const KTP_COMPANY_CODES = ['CMP000008']

const CTA = ({ type, startAt, endAt, ...props }: ICTAProps) => {
  const { code: companyCode } = useCompanyContext()
  const isKtpDomain = KTP_COMPANY_CODES.includes(companyCode)

  const content = useMemo(() => {
    switch (type) {
      case 'applyForm':
        return endAt ? <ApplyForm endAt={endAt} isKtpDomain={isKtpDomain} /> : null
      case 'applicationClosed':
        return <ApplicationClosed isKtpDomain={isKtpDomain} />
      case 'resumeApplication':
        return <ResumeApplication isKtpDomain={isKtpDomain} />
      case 'startLearning':
        return <StartLearning />
      case 'submissionComplete':
        return <SubmissionComplete />
      case 'applicationBefore':
        return startAt ? (
          <ApplicationBefore startAt={startAt} isKtpDomain={isKtpDomain} />
        ) : null
      case 'applicationNone':
        return <ApplicationNone />
      default:
        return null
    }
  }, [type, isKtpDomain, startAt, endAt])

  const bgClass = isKtpDomain
    ? type === 'applyForm' || type === 'resumeApplication'
      ? 'bg-[#3385FF]'
      : type === 'applicationClosed'
        ? 'bg-[#D1D1D1]'
        : 'bg-white'
    : 'bg-white'

  return content ? (
    <div
      className={`fixed bottom-0 left-0 z-10 flex w-full min-w-[360px] transform flex-col items-center justify-between gap-2.5 ${bgClass} px-5 pb-4 pt-3 backdrop-blur lg:bottom-6 lg:left-1/2 lg:w-[768px] lg:-translate-x-1/2 lg:flex-row lg:rounded-md lg:px-5 lg:py-3 lg:shadow-[0_4px_16px_0_rgba(0,0,0,0.2)]`}
      {...props}
    >
      {content}
    </div>
  ) : null
}

export default CTA
